<template>
  <div>
    <kChart />
  </div>
</template>

<script>
// import Editor from '@tinymce/tinymce-vue'
// // import Highcharts from 'highcharts/highstock';
// // import HighchartsMore from 'highcharts/highcharts-more';
// import * as echarts from 'echarts';
import kChart from '../components/chart//KLine/index.vue';

export default {
  data () {
    return {

    }
  },
  methods: {

  },
  components: {
    kChart
  },
  mounted () {

  },
  watch: {

  }
}
</script>
<style lang="less">
.editIframe {
  width: 100vw;
  height: 100vh;
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/app/test.vue